import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=37af33d2"
import script from "./Language.ts?vue&type=script&lang=ts&external"
export * from "./Language.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports